export default __webpack_public_path__ + "static/style-tip-fits-31badf6a8c9ad73cf68f5379ca1e65bb.png";